import React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import { SxProps, Theme } from '@mui/system';

import { useStore } from 'src/context/StoreContext';

type InputCustomProps = {
  labelInput?: string;
  name: string;
  value: string | number | null;
  sx?: SxProps<Theme>;
  sxInput?: SxProps<Theme>;
  readonly?: boolean;
  type: 'text' | 'number';
  onChange: (value: number | string | null) => void;
  min?: number;
  max?: number;
  error?: boolean;
};

const InputCustom: React.FC<InputCustomProps> = (props) => {
  const storeContext = useStore();
  const store = storeContext.store;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;

    if (props.type !== 'number' || 
        ((props.min === undefined || (Number(value) >= props.min)) 
        && (props.max === undefined || (Number(value) <= props.max)))) {
      props.onChange(value);
    }
  };

  const handleBeforeInput = (event: React.FormEvent<HTMLInputElement>) => {
    if (props.type === 'number') {
      const input = event.nativeEvent as InputEvent;
      const char = input.data;

      if (props.min === 0 && char && !/^[0-9.]$/.test(char)) {
        event.preventDefault();
      }

      if (char && /[+e]/.test(char)) {
        event.preventDefault();
      }
    }
  };

  return (
    <OutlinedInput
      fullWidth
      onBeforeInput={handleBeforeInput}
      readOnly={props.readonly}
      type={props.type}
      placeholder={props.labelInput}
      name={props.name}
      value={props.value !== null ? props.value : ''}
      onChange={handleChange}
      sx={{
        width: '160px',
        height: '48px',
        '& .MuiOutlinedInput-notchedOutline': { borderColor: props.error ? '#d32f2f !important' : '#BDBDBD' },
        '& .MuiInputBase-input': { p: '12px 16px' },
        '& input::placeholder': {
          fontSize: '12px',
          fontWeight: 400,
          color: '#AAB2BD',
          opacity: 1,
        },
        backgroundColor: store.palette.input.bgColor,
        ...props.sx
      }}
      inputProps={{
        ...(props.type === 'number' && {
          min: props.min,
          max: props.max,
        }),
        sx: {
          fontSize: '12px',
          fontWeight: 400,
          color: store.palette.input.color,
          backgroundColor: store.palette.input.bgColor,
          ...props.sxInput
        },
      }}
    />
  );
}

export default InputCustom;
